import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
/**
 * StandingOrderComponent
 */
let StandingOrderComponent = class StandingOrderComponent {
    constructor() {
    }
    ngOnInit() {
    }
};
StandingOrderComponent = __decorate([
    Component({
        selector: 'ecd-standing-order',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./standing-order.component.html")).default
    })
], StandingOrderComponent);
export { StandingOrderComponent };
